import type { ProjectTheme } from '@octopus-do/octopus-project-core'

import { colorSets, THEME_DARK, THEME_LIGHT } from '@/constants/constants'

export const toLightThemeColor = (colorHex: string, theme: ProjectTheme) => {
  if (!colorHex || theme !== THEME_DARK) {
    return colorHex
  }

  const sourceHex = colorHex.toUpperCase()
  const matchedByHex = colorSets[sourceHex]
  const matchedByDark = Object.values(colorSets).find((themeColorSet) => {
    const darkHex = themeColorSet[THEME_DARK]
    return darkHex?.toUpperCase() === sourceHex
  })

  const matchedColorSet = matchedByHex || matchedByDark
  const lightHex = matchedColorSet?.[THEME_LIGHT]

  return lightHex || colorHex
}
